<template>
  <v-container class="success-container">
    <v-row>
      <v-col xs="12" align="left" light>
        <p class="title">Thank You!</p>
        <p>Your dashboard account will be upgraded in the next minute or so.</p>
        <p>You can review ane make changes to your subscription on this site under the Account link at the top</p>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
export default {
  name: 'Success'
}
</script>

<style lang="scss" scoped>
.success-container {
  background-color: white;
  border-radius: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>